import script from "./SelectionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionMenu.vue?vue&type=script&setup=true&lang=js"

import "./SelectionMenu.vue?vue&type=style&index=0&id=85e3e07c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e3e07c"]])

export default __exports__